import Icons from "Components/Icons";
import React, { ReactChild, useState } from "react";
import css from "./Accordion.module.css";

const Accordion = ({
  title,
  children,
}: {
  title: string;
  children: ReactChild;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <article className={css.Container}>
      <header onClick={() => setOpen((prev) => !prev)} className={css.Header}>
        <h4>{title}</h4>
        <div>
          <Icons.Chevron direction={open ? "up" : "down"} />
        </div>
      </header>
      <section className={[css.Content, open ? css.Show : css.Hide].join(" ")}>
        <p>{children}</p>
      </section>
    </article>
  );
};

export default Accordion;
